import script from "./SearchResultsView.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchResultsView.vue?vue&type=script&setup=true&lang=js"

import "./SearchResultsView.vue?vue&type=style&index=0&id=7ffd18dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ffd18dc"]])

export default __exports__